import {
	Bell,
	CalendarDays,
	ClipboardList,
	FileSignature,
	Info,
	type LucideProps,
	Shield,
} from "lucide-react";
import type { ComponentType } from "react";
import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
	TimelineItemSubcategoryEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { TaskGlyphIcon } from "web_myplann/Shared/Icons/TaskGlyph";

export type TimelineIconProps = Pick<LucideProps, "size">;

export type TimelineIconTone =
	| "teal"
	| "green"
	| "orange"
	| "blue"
	| "purple"
	| "grey";

export type TimelineIconSpec = {
	Icon: ComponentType<TimelineIconProps>;
	tone: TimelineIconTone;
};

export const getTimelineIconSpec = (
	item: Pick<TimelineItemResponseDTO, "category" | "subcategory">,
): TimelineIconSpec => {
	if (item.subcategory) {
		return SUBCATEGORY_SPEC[item.subcategory];
	}
	return CATEGORY_SPEC[item.category];
};

const SUBCATEGORY_SPEC: Record<TimelineItemSubcategoryEnum, TimelineIconSpec> =
	{
		[TimelineItemSubcategoryEnum.ContractEnd]: { Icon: Shield, tone: "orange" },
		[TimelineItemSubcategoryEnum.ContractAnniversary]: {
			Icon: Shield,
			tone: "orange",
		},
		[TimelineItemSubcategoryEnum.ContractFixationEnd]: {
			Icon: Shield,
			tone: "orange",
		},
		[TimelineItemSubcategoryEnum.ClientActionMeetingRecord]: {
			Icon: FileSignature,
			tone: "blue",
		},
		[TimelineItemSubcategoryEnum.ClientActionInvestmentQuestionnaire]: {
			Icon: ClipboardList,
			tone: "blue",
		},
		[TimelineItemSubcategoryEnum.ReminderPortfolio]: {
			Icon: Bell,
			tone: "purple",
		},
		[TimelineItemSubcategoryEnum.ReminderProperty]: {
			Icon: Bell,
			tone: "purple",
		},
		[TimelineItemSubcategoryEnum.ReminderTerm]: { Icon: Bell, tone: "purple" },
		[TimelineItemSubcategoryEnum.NotificationTask]: {
			Icon: TaskGlyphIcon,
			tone: "green",
		},
		[TimelineItemSubcategoryEnum.NotificationActivity]: {
			Icon: CalendarDays,
			tone: "teal",
		},
	};

const CATEGORY_SPEC: Record<TimelineItemCategoryEnum, TimelineIconSpec> = {
	[TimelineItemCategoryEnum.Contract]: { Icon: Shield, tone: "orange" },
	[TimelineItemCategoryEnum.Activity]: { Icon: CalendarDays, tone: "teal" },
	[TimelineItemCategoryEnum.Reminder]: { Icon: Bell, tone: "purple" },
	[TimelineItemCategoryEnum.Task]: { Icon: TaskGlyphIcon, tone: "green" },
	[TimelineItemCategoryEnum.ClientAction]: {
		Icon: FileSignature,
		tone: "blue",
	},
	[TimelineItemCategoryEnum.Notification]: { Icon: Info, tone: "grey" },
};
